import React, { Component } from 'react';

import { getCharFilename } from './Utils.js';

class GamesList extends Component {
    render() {
        let data = this.props.data;
        let games = [];

        if (data) {
            for (let i=0; i<data.length; i++) {
                let focused = i === this.props.focused ? "focused" : "";

                let gameClass = "game-won";
                let gameScore = data[i].score;

                if (data[i]["dc"]) {
                    gameClass = "game-dc";
                    gameScore = "DC";
                } else if(!data[i]["has_stock_data"]) {
                    gameScore = data[i]["won"] ? "LOST" : "WON";
                    gameClass = data[i]["won"] ? "game-lost" : "game-won";
                } else if (data[i]["won"]) {
                    gameClass = "game-lost";
                    gameScore = "-" + gameScore;
                } else {
                    gameScore = "+" + Math.abs(gameScore);
                }
                if (data[i].sd) {
                    // handle sudden death
                    gameScore = "SD";
                }
                
                if (data[i]["game_type"] === "[fg_ts_2p_ga]") {
                    let c1 = getCharFilename(data[i]["characters"][2][0], data[i]["characters"][2][1], "blue");
                    let c2 = getCharFilename(data[i]["characters"][3][0], data[i]["characters"][3][1], "blue");
                    let c3 = getCharFilename(data[i]["characters"][0][0], data[i]["characters"][0][1], "red");
                    let c4 = getCharFilename(data[i]["characters"][1][0], data[i]["characters"][1][1], "red");

                    games.push(
                        <li key={"game-" + i} onClick={(e) => this.props.selectGame(i)} className={focused}>
                        <div className={gameClass}>
                            <h3 style={{width:"50px"}}>{gameScore}</h3>
                            <img src={c1} alt={this.props.i} />
                            <img src={c2} alt={this.props.i} />
                            <h3>vs</h3>
                            <img src={c3} alt={this.props.i} />
                            <img src={c4} alt={this.props.i} />
                          </div>
                        </li>
                    );
                } else if (data[i]["game_type"] === "[fg_11_ga]") {
                    let c1 = getCharFilename(data[i]["characters"][1][0], data[i]["characters"][1][1], "blue");
                    let c2 = getCharFilename(data[i]["characters"][0][0], data[i]["characters"][0][1], "red");

                    games.push(
                        <li key={"game-" + i} onClick={(e) => this.props.selectGame(i)} className={`game ${focused}`}>
                          <div className={`game-container ${gameClass}`}>
                            <h3 style={{width:"50px"}}>{gameScore}</h3>
                            <img src={c1} alt={this.props.i} />
                            <h3>vs</h3>
                            <img src={c2} alt={this.props.i} />
                          </div>
                        </li>
                    );
                }
            }
        }

        return (
            <div className="games-list-container">
              <ul className="games-list">
                {games}
              </ul>
            </div>
        );
    }
}

export default GamesList;
